var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#2B2826"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -4.19999,
    y: -6.19999,
    width: 48.4,
    height: 48.4
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6.4px)",
      clipPath: "url(#bgblur_0_11072_82377_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11072_82377)",
    "data-figma-bg-blur-radius": 12.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_11072_82377",
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 6,
    width: 24,
    height: 24,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 8,
    y: 6,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8643 18.2451V28L21.7705 21.0059L28.6553 24.7822C26.6415 27.3485 23.5151 29 20 29C13.9249 29 9 24.0751 9 18C9 16.6423 9.24648 15.3423 9.69629 14.1416L16.8643 18.2451ZM20 7C26.0751 7 31 11.9249 31 18C31 20.3825 30.2393 22.5857 28.9521 24.3867L24.0342 17.4482L26.4189 14.0859H21.5146L16.8643 8V14.0859H9.71875C11.2966 9.94364 15.3037 7 20 7Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.8643 18.2451V28L21.7705 21.0059L28.6553 24.7822C26.6415 27.3485 23.5151 29 20 29C13.9249 29 9 24.0751 9 18C9 16.6423 9.24648 15.3423 9.69629 14.1416L16.8643 18.2451ZM20 7C26.0751 7 31 11.9249 31 18C31 20.3825 30.2393 22.5857 28.9521 24.3867L24.0342 17.4482L26.4189 14.0859H21.5146L16.8643 8V14.0859H9.71875C11.2966 9.94364 15.3037 7 20 7Z",
    fill: "url(#paint0_linear_11072_82377)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8643 18.2451H17.2643V18.0132L17.063 17.898L16.8643 18.2451ZM16.8643 28H16.4643V29.2668L17.1917 28.2297L16.8643 28ZM21.7705 21.0059L21.9629 20.6552L21.6488 20.4829L21.443 20.7761L21.7705 21.0059ZM28.6553 24.7822L28.97 25.0292L29.261 24.6583L28.8476 24.4315L28.6553 24.7822ZM9.69629 14.1416L9.89502 13.7945L9.48675 13.5607L9.32171 14.0013L9.69629 14.1416ZM28.9521 24.3867L28.6258 24.618L28.9508 25.0765L29.2776 24.6193L28.9521 24.3867ZM24.0342 17.4482L23.7079 17.2168L23.5438 17.4482L23.7078 17.6796L24.0342 17.4482ZM26.4189 14.0859L26.7452 14.3173L27.193 13.6859H26.4189V14.0859ZM21.5146 14.0859L21.1968 14.3288L21.3169 14.4859H21.5146V14.0859ZM16.8643 8L17.1821 7.75714L16.4643 6.81771V8H16.8643ZM16.8643 14.0859V14.4859H17.2643V14.0859H16.8643ZM9.71875 14.0859L9.34495 13.9436L9.13835 14.4859H9.71875V14.0859ZM16.8643 18.2451H16.4643V28H16.8643H17.2643V18.2451H16.8643ZM16.8643 28L17.1917 28.2297L22.098 21.2356L21.7705 21.0059L21.443 20.7761L16.5368 27.7703L16.8643 28ZM21.7705 21.0059L21.5781 21.3566L28.4629 25.1329L28.6553 24.7822L28.8476 24.4315L21.9629 20.6552L21.7705 21.0059ZM28.6553 24.7822L28.3406 24.5353C26.3992 27.0094 23.3867 28.6 20 28.6V29V29.4C23.6434 29.4 26.8839 27.6876 28.97 25.0292L28.6553 24.7822ZM20 29V28.6C14.1458 28.6 9.4 23.8542 9.4 18H9H8.6C8.6 24.296 13.704 29.4 20 29.4V29ZM9 18H9.4C9.4 16.6911 9.63757 15.4385 10.0709 14.2819L9.69629 14.1416L9.32171 14.0013C8.85538 15.246 8.6 16.5936 8.6 18H9ZM9.69629 14.1416L9.49756 14.4887L16.6655 18.5923L16.8643 18.2451L17.063 17.898L9.89502 13.7945L9.69629 14.1416ZM20 7V7.4C25.8542 7.4 30.6 12.1458 30.6 18H31H31.4C31.4 11.704 26.296 6.6 20 6.6V7ZM31 18H30.6C30.6 20.2959 29.8673 22.4184 28.6267 24.1541L28.9521 24.3867L29.2776 24.6193C30.6114 22.7531 31.4 20.4691 31.4 18H31ZM28.9521 24.3867L29.2785 24.1554L24.3605 17.2169L24.0342 17.4482L23.7078 17.6796L28.6258 24.618L28.9521 24.3867ZM24.0342 17.4482L24.3604 17.6797L26.7452 14.3173L26.4189 14.0859L26.0927 13.8545L23.7079 17.2168L24.0342 17.4482ZM26.4189 14.0859V13.6859H21.5146V14.0859V14.4859H26.4189V14.0859ZM21.5146 14.0859L21.8325 13.8431L17.1821 7.75714L16.8643 8L16.5464 8.24286L21.1968 14.3288L21.5146 14.0859ZM16.8643 8H16.4643V14.0859H16.8643H17.2643V8H16.8643ZM16.8643 14.0859V13.6859H9.71875V14.0859V14.4859H16.8643V14.0859ZM9.71875 14.0859L10.0925 14.2283C11.6133 10.2359 15.4753 7.4 20 7.4V7V6.6C15.1322 6.6 10.9799 9.65139 9.34495 13.9436L9.71875 14.0859Z",
    fill: "#C58000",
    fillOpacity: 0.48,
    mask: "url(#path-2-outside-1_11072_82377)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11072_82377",
    x: -4.19999,
    y: -6.19999,
    width: 48.4,
    height: 48.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.899346 0 0 0 0 0.713726 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11072_82377"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11072_82377",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_11072_82377_clip_path",
    transform: "translate(4.19999 6.19999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8643 18.2451V28L21.7705 21.0059L28.6553 24.7822C26.6415 27.3485 23.5151 29 20 29C13.9249 29 9 24.0751 9 18C9 16.6423 9.24648 15.3423 9.69629 14.1416L16.8643 18.2451ZM20 7C26.0751 7 31 11.9249 31 18C31 20.3825 30.2393 22.5857 28.9521 24.3867L24.0342 17.4482L26.4189 14.0859H21.5146L16.8643 8V14.0859H9.71875C11.2966 9.94364 15.3037 7 20 7Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11072_82377",
    x1: 20,
    y1: 20.2046,
    x2: 20,
    y2: 26.2296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFBAA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.35958062a927c1d9484f26ee0798bd3c.svg";
export { ForwardRef as ReactComponent };